import { REVIEW_LOCK_TEXT } from '@/features/editor/lib/reviewLockText'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Подсказка погашенной кнопки таймлайна: нет прав важнее проверки — автору
 *  без прав решение проверки ничего не откроет. */
export const lockHint = (isCourseAuthor: boolean, isFrozen: boolean): string | undefined => {
  if (!isCourseAuthor) return messagesNow(messages).noRights
  return isFrozen ? REVIEW_LOCK_TEXT : undefined
}
